import '../styles/Footer.scss'

const Footer = () => {
    return (
        <div className="footer">
            <p>&copy; Copyright 2023, Abdul-Rahime Kadri</p>
        </div>
    )
}

export default Footer